/** How far a custom clickable fades while it is pressed. */
export const PRESSED_OPACITY = 0.7;

/**
 * The faded look of a pressed clickable. Doubling the class (`&&`) puts it
 * above the element's own `&:hover` rule, which a touch screen leaves applied
 * after a tap.
 */
export const PRESSED_LOOK = { '&&': { opacity: PRESSED_OPACITY } } as const;

/**
 * The same look from CSS `:active`, as a fallback where no pointer event
 * arrives for a press. It only ever sets the same opacity on the same element,
 * so it cannot dim twice. Not for elements with controls inside them:
 * `:active` also matches the ancestors of the pressed element.
 */
export const ACTIVE_FALLBACK_LOOK = { '&&:active': { opacity: PRESSED_OPACITY } } as const;
